import React from "react";

// Served from the frontend's own /public folder — same origin as the deployed
// app, so this survives on any domain (kelta.co.in, preview, custom domains).
export const LOGO_CREST = process.env.PUBLIC_URL + "/kelta-crest.jpg";
export const LOGO_WORDMARK = process.env.PUBLIC_URL + "/kelta-wordmark.jpg";

export function Crest({ size = 40, className = "" }) {
  return (
    <img
      src={LOGO_CREST}
      alt="KELTA emblem"
      width={size}
      height={size}
      className={`object-contain ${className}`}
      style={{ width: size, height: size, mixBlendMode: "multiply" }}
    />
  );
}

export function Wordmark({ className = "" }) {
  return (
    <img
      src={LOGO_WORDMARK}
      alt="KELTA — Kerala Local Body Technical Assistants Association"
      className={`object-contain ${className}`}
      style={{ mixBlendMode: "multiply" }}
    />
  );
}
